var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("normalDialog", {
    attrs: {
      title: _vm.$t(
        "label_essweb_leaveType_form_dialog_editLeaveTransactionTypeTitle"
      ),
      dialog: _vm.show,
      width: "600",
      scrollable: "",
    },
    on: { close: _vm.closeDialog },
    scopedSlots: _vm._u([
      {
        key: "content",
        fn: function () {
          return [
            _c(
              "v-form",
              { ref: "form" },
              [
                _c(
                  "v-row",
                  [
                    _c(
                      "v-col",
                      {
                        attrs: {
                          xs: "12",
                          sm: "12",
                          md: "12",
                          lg: "12",
                          cols: "12",
                        },
                      },
                      [
                        _c("inputTextFiledMultiLang", {
                          attrs: {
                            bindData:
                              _vm.leaveTransactionTypeData
                                .leave_transaction_type_name,
                            maxlength: "100",
                            TrigerInit: _vm.show,
                            label: _vm.$t(
                              "label_essweb_leaveType_form_dialog_leaveTransactionTypeNameLabel"
                            ),
                            rules: _vm.$GetRules(["_Require_Rules"], [null]),
                          },
                          on: {
                            change: function (valueArr) {
                              _vm.leaveTransactionTypeData.leave_transaction_type_name =
                                valueArr
                            },
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      {
                        attrs: {
                          xs: "12",
                          sm: "6",
                          md: "6",
                          lg: "6",
                          cols: "12",
                        },
                      },
                      [
                        _c(
                          "v-sheet",
                          { staticClass: "mrc_text_require text--secondary" },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "label_essweb_leaveType_form_dialog_calculationMethodLabel"
                                )
                              )
                            ),
                          ]
                        ),
                        _c("v-autocomplete", {
                          attrs: {
                            items: _vm.Calculations,
                            filled: "",
                            "item-value": "value_field",
                            "item-text": "view_fields",
                            "single-line": "",
                            rules: _vm.$GetRules("_Require_Rules", [null]),
                            dense: "",
                            label: _vm.$t(
                              "label_essweb_leaveType_form_dialog_calculationMethodLabel"
                            ),
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "no-data",
                              fn: function () {
                                return [_c("noContent")]
                              },
                              proxy: true,
                            },
                            {
                              key: "selection",
                              fn: function (ref) {
                                var item = ref.item
                                var index = ref.index
                                return [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$getCommonLangValue(
                                          item.view_fields
                                        )
                                      ) +
                                      " "
                                  ),
                                ]
                              },
                            },
                            {
                              key: "item",
                              fn: function (ref) {
                                var item = ref.item
                                var index = ref.index
                                return [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$getCommonLangValue(
                                          item.view_fields
                                        )
                                      ) +
                                      " "
                                  ),
                                ]
                              },
                            },
                          ]),
                          model: {
                            value:
                              _vm.leaveTransactionTypeData.calculation_method,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.leaveTransactionTypeData,
                                "calculation_method",
                                $$v
                              )
                            },
                            expression:
                              "leaveTransactionTypeData.calculation_method",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      {
                        attrs: {
                          xs: "12",
                          sm: "6",
                          md: "6",
                          lg: "6",
                          cols: "12",
                        },
                      },
                      [
                        _c("normalInputTextFiled", {
                          attrs: {
                            type: "number",
                            isNotRequire: "",
                            maxlength: "255",
                            rules: _vm.$GetRules(
                              ["_Number_negative", "_Length_Rules"],
                              [null, 255]
                            ),
                            label: _vm.$t(
                              "label_essweb_leaveType_form_dialog_sequenceLabel"
                            ),
                          },
                          model: {
                            value: _vm.leaveTransactionTypeData.sequence,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.leaveTransactionTypeData,
                                "sequence",
                                $$v
                              )
                            },
                            expression: "leaveTransactionTypeData.sequence",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      {
                        attrs: {
                          xs: "12",
                          sm: "12",
                          md: "6",
                          lg: "6",
                          cols: "12",
                        },
                      },
                      [
                        _c(
                          "v-sheet",
                          { staticClass: "mrc_text_require text--secondary" },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "label_essweb_leaveType_form_dialog_enumerationCodeLabel"
                                )
                              )
                            ),
                          ]
                        ),
                        _c("v-autocomplete", {
                          attrs: {
                            items: _vm.TransactionCode,
                            filled: "",
                            "item-value": "value_field",
                            "item-text": "view_fields",
                            "single-line": "",
                            rules: _vm.$GetRules("_Require_Rules", [null]),
                            dense: "",
                            label: _vm.$t(
                              "label_essweb_leaveType_form_dialog_enumerationCodeLabel"
                            ),
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "no-data",
                              fn: function () {
                                return [_c("noContent")]
                              },
                              proxy: true,
                            },
                            {
                              key: "selection",
                              fn: function (ref) {
                                var item = ref.item
                                var index = ref.index
                                return [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$getCommonLangValue(
                                          item.view_fields
                                        )
                                      ) +
                                      " "
                                  ),
                                ]
                              },
                            },
                            {
                              key: "item",
                              fn: function (ref) {
                                var item = ref.item
                                var index = ref.index
                                return [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$getCommonLangValue(
                                          item.view_fields
                                        )
                                      ) +
                                      " "
                                  ),
                                ]
                              },
                            },
                          ]),
                          model: {
                            value:
                              _vm.leaveTransactionTypeData
                                .leave_transaction_type_code,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.leaveTransactionTypeData,
                                "leave_transaction_type_code",
                                $$v
                              )
                            },
                            expression:
                              "leaveTransactionTypeData.leave_transaction_type_code",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      {
                        attrs: {
                          xs: "12",
                          sm: "12",
                          md: "6",
                          lg: "6",
                          cols: "12",
                        },
                      },
                      [
                        _c("v-sheet", { staticClass: "text--secondary" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "label_essweb_RosterTemplate_form_setAsDefault"
                              )
                            )
                          ),
                        ]),
                        _c("v-autocomplete", {
                          attrs: {
                            items: _vm.trueFalse,
                            "item-value": "value_field",
                            "item-text": "view_fields",
                            filled: "",
                            "single-line": "",
                            dense: "",
                            label: _vm.$t(
                              "label_essweb_RosterTemplate_form_setAsDefault"
                            ),
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "no-data",
                              fn: function () {
                                return [_c("noContent")]
                              },
                              proxy: true,
                            },
                            {
                              key: "selection",
                              fn: function (data) {
                                return [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$getCommonLangValue(
                                          data.item.view_fields
                                        )
                                      ) +
                                      " "
                                  ),
                                ]
                              },
                            },
                            {
                              key: "item",
                              fn: function (data) {
                                return [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$getCommonLangValue(
                                          data.item.view_fields
                                        )
                                      ) +
                                      " "
                                  ),
                                ]
                              },
                            },
                          ]),
                          model: {
                            value: _vm.leaveTransactionTypeData.is_default,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.leaveTransactionTypeData,
                                "is_default",
                                $$v
                              )
                            },
                            expression: "leaveTransactionTypeData.is_default",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      {
                        attrs: {
                          xs: "12",
                          sm: "12",
                          md: "12",
                          lg: "12",
                          cols: "12",
                        },
                      },
                      [
                        _c("v-sheet", { staticClass: "text--secondary" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "label_essweb_leaveType_form_dialog_codeLabel"
                              )
                            )
                          ),
                        ]),
                        _c("v-text-field", {
                          attrs: {
                            dense: "",
                            filled: "",
                            "single-line": "",
                            label: _vm.$t(
                              "label_essweb_leaveType_form_dialog_codeLabel"
                            ),
                            maxlength: "100",
                          },
                          model: {
                            value:
                              _vm.leaveTransactionTypeData
                                .leave_transaction_type_common_code,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.leaveTransactionTypeData,
                                "leave_transaction_type_common_code",
                                $$v
                              )
                            },
                            expression:
                              "\n              leaveTransactionTypeData.leave_transaction_type_common_code\n            ",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      {
                        attrs: {
                          xs: "12",
                          sm: "12",
                          md: "12",
                          lg: "12",
                          cols: "12",
                        },
                      },
                      [
                        _c("inputTextFiledMultiLang", {
                          attrs: {
                            maxlength: "500",
                            bindData:
                              _vm.leaveTransactionTypeData
                                .leave_transaction_type_description,
                            TrigerInit: _vm.show,
                            label: _vm.$t(
                              "label_essweb_leaveType_form_dialog_descriptionLabel"
                            ),
                          },
                          on: {
                            change: function (valueArr) {
                              _vm.leaveTransactionTypeData.leave_transaction_type_description =
                                valueArr
                            },
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      {
                        attrs: {
                          xs: "12",
                          sm: "12",
                          md: "12",
                          lg: "12",
                          cols: "12",
                        },
                      },
                      [
                        _c(
                          "v-sheet",
                          { staticClass: "mrc_text_require text--secondary" },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "label_essweb_leaveType_form_dialog_leaveTransactionGroupLabel"
                                )
                              )
                            ),
                          ]
                        ),
                        _c("v-autocomplete", {
                          attrs: {
                            items: _vm.LeaveTranPG,
                            "item-value": "uuid",
                            "item-text":
                              "leave_transaction_type_property_group_code",
                            filled: "",
                            "single-line": "",
                            rules: _vm.$GetRules("_Require_Rules", [null]),
                            dense: "",
                            label: _vm.$t(
                              "label_essweb_leaveType_form_dialog_leaveTransactionGroupLabel"
                            ),
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "no-data",
                              fn: function () {
                                return [_c("noContent")]
                              },
                              proxy: true,
                            },
                            {
                              key: "selection",
                              fn: function (data) {
                                return [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$getCommonLangValue(
                                          data.item
                                            .leave_transaction_type_property_group_name
                                        )
                                      ) +
                                      " "
                                  ),
                                ]
                              },
                            },
                            {
                              key: "item",
                              fn: function (data) {
                                return [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$getCommonLangValue(
                                          data.item
                                            .leave_transaction_type_property_group_name
                                        )
                                      ) +
                                      " "
                                  ),
                                ]
                              },
                            },
                          ]),
                          model: {
                            value:
                              _vm.leaveTransactionTypeData
                                .leave_transaction_type_property_group_uuid,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.leaveTransactionTypeData,
                                "leave_transaction_type_property_group_uuid",
                                $$v
                              )
                            },
                            expression:
                              "\n              leaveTransactionTypeData.leave_transaction_type_property_group_uuid\n            ",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "actions",
        fn: function () {
          return [
            _c("CardActions", {
              attrs: { saveBtn: "" },
              on: { save: _vm.toEdit, cancel: _vm.closeDialog },
            }),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }